declare let Object: any;

export interface WorkflowEventInterface {
    'id'?: string;
    'name'?: string;
}

export class WorkflowEvent implements WorkflowEventInterface {
    'id'?: string;
    'name'?: string;
    constructor(data?: WorkflowEventInterface) {
        Object.assign(this, data);
    }
    /**
     * The name of the model represented by this $resource,
     * i.e. `WorkflowEvent`.
     */
    public static getModelName() {
        return 'WorkflowEvent';
    }
    /**
    * @method factory
    * @author Jonathan Casarrubias
    * @license MIT
    * This method creates an instance of WorkflowEvent for dynamic purposes.
    **/
    public static factory(data: WorkflowEventInterface): WorkflowEvent {
        return new WorkflowEvent(data);
    }
    /**
    * @method getModelDefinition
    * @author Julien Ledun
    * @license MIT
    * This method returns an object that represents some of the model
    * definitions.
    **/
    public static getModelDefinition() {
        return {
            name: 'WorkflowEvent',
            plural: 'WorkflowEvents',
            path: 'workflow-events',
            idName: 'id',
            properties: {
                'id': {
                    name: 'id',
                    type: 'string'
                },
                'name': {
                    name: 'name',
                    type: 'string'
                }
            },
            relations: {}
        };
    }
}
